import React, { useState, useEffect, useRef, Component } from 'react';
import { Button, Offcanvas, Form, Modal } from 'react-bootstrap';
import * as commonService from '../services/commonService';
import * as userGamesController from '../controller/userGamesController';
import { useNavigate } from 'react-router-dom';
import { pageURLs } from '../appData/pageURLs';
import useUserState from '../appState/userState/useUserState';
import * as transactionController from '../controller/transactionController';
import * as userController from '../controller/userController';
import useGeoLocation from '../utils/useGeoLocation';

import * as GIDX from 'gidx-js';
import Dotimg from '../assets/card-dots.svg';
import Plusimg from '../assets/plus-icon.svg';
import Deleteicon from '../assets/trash-can-icon.svg';
import { store } from '../appState/store';
import KORadiobutton from '../components/KORadiobutton';

const CreateLeagueStepPayment = (props) => {
  const location = useGeoLocation();

  const user = useUserState();
  const editAction = props.editAction;
  const userData = store.getState().user;
  const [show4, setShow4] = useState(true);
  const [inviteEmail, setInviteEmail] = useState('');
  const [invitedEmailList, setInvitedEmailList] = useState([]);
  const [inviteEmailAdd, setInviteEmailAdd] = useState([]);
  const [inviteEmailError, setInviteEmailError] = useState('');
  const [paymentSession, setPaymentSession] = useState('');
  const [paymentProcessFlag, SetPaymentProcessFlag] = useState(false);
  const [showLoader, SetShowLoader] = useState(true);
  const [stepState, setStepState] = useState('');
  const [showDeleteEmailConfirmModal, setDeleteEmailConfirmModal] =
    useState(false);
  const deleteEmailConfirmModalClose = () => setDeleteEmailConfirmModal(false);
  const deleteEmailConfirmModalShow = () => setDeleteEmailConfirmModal(true);
  const [paymentError, SetPaymentError] = useState('');
  const [cordinates, setCordinates] = useState({});
  const [showLocationRequiredPopup, setLocationRequiredPopup] = useState(false);
  const [tsevoReconfirmationMessage, settsevoReconfirmationMessage] = useState(
    'Allow the browser to access your location and complete the payment?'
  );
  const [tsevoRefreshMessage, settsevoRefreshMessage] = useState(
    'Permission to access your location is required to complete the payment. Please allow the browser to access your location. After that please click refresh button.'
  );

  const [geoLocationAvailable, setGeoLocationAvailable] = useState(false);
  const [geoLocationEnabled, setGeoLocationEnabled] = useState(false);
  const [showLocationDisabledMsg, setLocationDisabledMsg] = useState(false);
  const [paymentSessionURL, setPaymentSessionURL] = useState('');
  const [isIpisV4, setisIpisV4] = useState(false);
  const containerRef = useRef(null);
  const [sessionData, setSessionData] = useState(null);
  const [customerCards, setCustomerCards] = useState([]);
  const [selectedCardToken, setSelectedCardToken] = useState(null);
  const [showNewCardAddForm, setShowNewCardAddForm] = useState(false);
  const [selectedCardNumber, setSelectedCardNumber] = useState(null);
  const [customerDeviceIp, setCustomerDeviceIp] = useState(null);
  const [creditCardpaymentCompleted, setCreditCardPaymentCompleted] =
    useState(false);
  const [cardDisplayFormTitle, setCardDisplayFormTitle] =
    useState('Add New Card');
  const [displayAddNewCardButton, setDisplayAddNewCardButton] = useState(false);
  const [addingNewCreditCard, setAddingNewCreditCard] = useState(false);
  let ccForm = null;
  const ccformRef = useRef(null); // Store GIDX form object
  const contest_id = props.contest_id;
  const navigate = useNavigate();

  const makePayment = async (cordinatesData) => {
    SetPaymentProcessFlag(true);
    SetShowLoader(true);
    SetPaymentError('');
    await userController.getUserIp().then(async function (ipdata) {
      let customerIp = ipdata.data ? ipdata.data.IPv4 : null;
      if (customerIp) {
        setCustomerDeviceIp(customerIp);
        await transactionController
          .makeUserGamePayment(customerIp, cordinatesData, contest_id)
          .then(async function (orderData) {
            if (orderData.errorCode == 200) {
              SetPaymentProcessFlag(true);
              setSessionData(orderData);
            } else {
              SetPaymentProcessFlag(false);
              SetShowLoader(false);
              SetPaymentError(orderData.message);
            }
          });
      } else {
        SetPaymentProcessFlag(false);
        SetShowLoader(false);
        SetPaymentError(
          'Could not process the request. Please try again later.'
        );
      }
    });
  };

  const showPaymentProcessModal = async () => {
    props.setPaymentDone(true);
  };

  const enableLocationPopup = () => {
    setLocationRequiredPopup(false);
  };

  useEffect(() => {
    if (location.loaded && !location.errorFlag && !paymentSession) {
      Locationsuccess(location.coordinates);
    } else if (location.loaded && location.errorFlag && !paymentSession) {
      Locationerror();
    }
  }, [location]);

  const cancelLocationRequiredPopup = () => {
    SetPaymentProcessFlag(false);
    SetShowLoader(false);
    setLocationRequiredPopup(false);
    setLocationDisabledMsg(true);
  };
  const Locationsuccess = async (cordinatesData) => {
    // console.log(gotPosition)
    setGeoLocationAvailable(true);
    setGeoLocationEnabled(true);
    setLocationDisabledMsg(false);
    setCordinates(cordinatesData);
    makePayment(cordinatesData);
  };

  const Locationerror = async (err) => {
    setLocationRequiredPopup(true);
  };

  useEffect(() => {
    if (!sessionData) return;

    const merchantId =
      sessionData?.data?.MerchantID ?? process.env.REACT_APP_TSEVO_MERCHANT_ID;
    const environment = process.env.REACT_APP_TSEVO_ENVIRONMENT ?? 'production';

    // Initialize GIDX
    GIDX.init({ merchantId, environment });

    // Find CC settings from response
    const ccSettings = sessionData?.data?.PaymentMethodSettings?.find(
      (s) => s.Type === 'CC'
    );
    if (!ccSettings) {
      throw new Error('No CC settings found in CreateSession response');
    }
    const ccPayments =
      sessionData?.data?.PaymentMethods?.filter(
        (payment) => payment.Type === 'CC'
      ) ?? [];
    // 🚀 Show loader before starting form render
    SetShowLoader(true);
    setCustomerCards(ccPayments);
    if (selectedCardNumber === null) {
      const defaultSelectedCard =
        ccPayments?.length > 0 ? ccPayments[0].Token : null;
      const defaultSelectedCardNumber =
        ccPayments?.length > 0 ? ccPayments[0].LastFour : null;
      setSelectedCardToken(defaultSelectedCard);
      setSelectedCardNumber(defaultSelectedCardNumber);
    }
    // Remove old form before creating a new one
    if (ccformRef.current) {
      if (typeof ccformRef.current.destroy === 'function') {
        ccformRef.current.destroy();
      } else {
        containerRef.current.innerHTML = ''; // fallback
      }
      ccformRef.current = null;
    }
    // Start observing the container for changes(For showing loader while loading the card form)
    const observer = new MutationObserver(() => {
      if (containerRef.current && containerRef.current.children.length > 0) {
        // Form content appeared → hide loader
        SetShowLoader(false);
        observer.disconnect();
      }
    });
    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }
    const shouldShowFullForm = showNewCardAddForm || ccPayments?.length === 0;
    if (shouldShowFullForm && ccSettings?.Tokenizer) {
      setAddingNewCreditCard(true);
      setDisplayAddNewCardButton(false);
      setCardDisplayFormTitle('Add New Card');
      setSelectedCardToken(null);
      setSelectedCardNumber(null);
      console.log(
        'showNewCardAddForm is true, resetting selected card token and number',
        ccSettings.Tokenizer
      );
      // Render the GIDX form
      ccForm = GIDX.showPaymentMethodForm(containerRef.current.id, {
        merchantSessionId: sessionData?.data?.MerchantSessionID,
        paymentMethodTypes: ['CC'],
        tokenizer: ccSettings.Tokenizer,
        theme: 'material',
        styles: {
          base: {
            fontSize: '20px',
            color: '#fff',
            fontFamily: 'Poppins, sans-serif',
          },
          label: {
            color: '#fff !important',
          },
          input: {
            borderRadius: '8px',
            border: '1px solid #ccc',
            padding: '25px',
          },
        },
        fields: ['name', 'number', 'expiry', 'cvc'],
      });

      ccformRef.current = ccForm; // Store form instance
    } else if (ccPayments?.length > 0 && ccSettings?.Tokenizer) {
      setAddingNewCreditCard(false);
      setCardDisplayFormTitle('CVV');
      setDisplayAddNewCardButton(true);
      ccformRef.current = GIDX.showPaymentMethodForm(containerRef.current.id, {
        merchantSessionId: sessionData?.data?.MerchantSessionID,
        paymentMethodTypes: ['CC'],
        tokenizer: ccSettings.Tokenizer,
        cvvOnly: true,
        theme: 'material',
        styles: {
          base: {
            fontSize: '20px',
            color: '#fff',
            fontFamily: 'Poppins, sans-serif',
          },
          label: {
            color: '#fff !important',
          },
          input: {
            borderRadius: '8px',
            border: '1px solid #ccc',
            padding: '25px',
          },
        },
        existingPaymentMethodToken: selectedCardToken,
        fields: ['name', 'number', 'expiry', 'cvc'],
      });
    } else {
      SetPaymentError('Could not process the request. Please try again later.');
      SetShowLoader(false);
      setSessionData(null);
      SetPaymentProcessFlag(false);
    }
  }, [showNewCardAddForm, sessionData]);

  const handleCardSelect = (selectedToken, selectedNumber) => {
    setSelectedCardToken(selectedToken);
    setSelectedCardNumber(selectedNumber);
    setShowNewCardAddForm(false);
    setCardDisplayFormTitle('CVV');
    setDisplayAddNewCardButton(true);
    setAddingNewCreditCard(false);
  };
  // complete the cc payment
  const completeCreditCardPayment = async () => {
    SetShowLoader(true);
    SetPaymentError('');
    const paymentPayload = {
      transaction_action: 'deposit',
      customerIp: customerDeviceIp,
      time: new Date(),
      accuracy: cordinates.accuracy ? cordinates.accuracy : null,
      altitude: cordinates.altitude ? cordinates.altitude : null,
      latitude: cordinates.latitude ? cordinates.latitude : null,
      longitude: cordinates.longitude ? cordinates.longitude : null,
      speed: cordinates.speed ? cordinates.speed : null,
      paymentType: 'CC',
      paymentMethodToken: null,
      savePaymentMethod: false,
      existingPaymentMethod: false,
      currentSessionID: sessionData?.data?.transaction_id,
      paymentMethod: {
        Type: 'CC',
        NameOnAccount: '',
        CVV: '',
        ExpirationDate: '',
        ProcessorToken: {
          Processor: 'Evervault',
          Token: '',
        },
      },
      context: 'usergame',
    };
    let callAPI = false;
    if (
      ccformRef.current &&
      addingNewCreditCard &&
      ccformRef?.current?.card?.values?.isValid
    ) {
      callAPI = true;
      // console.log(ccformRef.current);
      paymentPayload.paymentMethod.NameOnAccount =
        ccformRef?.current?.card?.values?.card?.name;
      paymentPayload.paymentMethod.CVV =
        ccformRef?.current?.card?.values?.card?.cvc;
      paymentPayload.paymentMethod.ExpirationDate = `${ccformRef?.current?.card?.values?.card?.expiry?.month}/${ccformRef?.current?.card?.values?.card?.expiry?.year}`;
      paymentPayload.paymentMethod.ProcessorToken.Token =
        ccformRef?.current?.card?.values?.card?.number;
      paymentPayload.savePaymentMethod = true;
    } else if (
      !addingNewCreditCard &&
      ccformRef?.current?.card?.values?.isValid
    ) {
      callAPI = true;
      paymentPayload.paymentMethodToken = selectedCardToken;
      paymentPayload.existingPaymentMethod = true;
      paymentPayload.paymentMethod.CVV =
        ccformRef?.current?.card?.values?.card?.cvc;
      // console.log('Submitting payment without new card form', paymentPayload);
      // Handle payment submission without new card form
    } else {
      SetPaymentError('Please enter a valid card details');
      SetShowLoader(false);
    }
    if (callAPI === true) {
      const data =
        await transactionController.completeDirectCCSession(paymentPayload);
      SetShowLoader(false);
      if (data?.errorCode === 200) {
        if (data?.data?.Action?.Type == '3DSChallenge') {
          GIDX.show3DSChallenge(data?.data?.Action, {
            onComplete: async function (transactionId) {
              //Send another CompleteSession request after challenge is completed.
              delete paymentPayload.paymentMethod;
              paymentPayload.Type = 'CC';
              paymentPayload.ThreeDS = {
                TransactionID: transactionId,
              };
              paymentPayload.paymentMethodToken =
                data?.data?.PaymentDetails[0]?.PaymentMethodToken;
              SetShowLoader(true);
              //Call CompleteSession API here
              const challengeResponse =
                await transactionController.completeDirectCCSession(
                  paymentPayload
                );
              SetShowLoader(false);
              if (
                challengeResponse?.errorCode === 200 &&
                challengeResponse?.data?.PaymentDetails &&
                challengeResponse?.data?.PaymentDetails[0].PaymentStatusCode ===
                  "1"
              ) {
                showPaymentProcessModal();
                setCreditCardPaymentCompleted(true);
              } else {
                SetPaymentError(
                  'Could not process the request. Please try again later.'
                );
                setSessionData(null);
                SetPaymentProcessFlag(false);
              }
            },
          });
        } else {
          showPaymentProcessModal();
          setCreditCardPaymentCompleted(true);
        }
      } else {
        SetPaymentError(data?.message || 'Payment failed. Please try again.');
      }
    }
  };

  const showCardClass = (cardType = 'Visa') => {
    let result = 'credit-card';
    if (cardType === 'MasterCard') {
      result += ' card-2';
    } else {
      result += ' card-1';
    }
    return result;
  };

  return (
    <>
      <div
        className="field-container payment-container"
        style={{ display: show4 ? 'block' : 'none' }}
      >
        <div className="invite-details">
          <h4>Payment</h4>
          {showLoader && (
            <div className="loader-wrap">
              <div className="loader"></div>
            </div>
          )}

          <div className="payment-data">
            {paymentProcessFlag && !creditCardpaymentCompleted ? (
              <>
                <div className="payment-card-sec">
                  {customerCards.length > 0 ? (
                    <>
                      <div className="card-title-block">
                        <h4 className="text-start mb-3">Saved Cards</h4>
                        <p>
                          You can add your credit card for the feature purchase
                          and automatically renew.
                        </p>
                      </div>
                      <div className="credit-card-group d-flex">
                        {customerCards.map((cc, index) => (
                          <div
                            className={showCardClass(cc.Network)}
                            key={cc.Token || index}
                          >
                            <div className="card-number d-flex align-items-center">
                              <img src={Dotimg} alt="Card Dots" />
                              <h4 className="m-0">{cc.LastFour}</h4>
                            </div>
                            <div className="name-expiry d-flex justify-content-between">
                              <h4 className="m-0">{cc.NameOnAccount}</h4>
                              <h4 className="m-0">{cc.ExpirationDate}</h4>
                            </div>
                            <div className="card-actions d-flex align-items-center justify-content-between">
                              <div className="form-group m-0">
                                <KORadiobutton
                                  name="creditCard"
                                  id={`creditCard_${index}`}
                                  value={cc.Token}
                                  label=""
                                  onChange={() =>
                                    handleCardSelect(cc.Token, cc.LastFour)
                                  }
                                  checked={selectedCardToken === cc.Token}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                  {displayAddNewCardButton && (
                    <Button
                      variant="primary"
                      className="btn-main add-btn d-flex align-items-center"
                      onClick={() => setShowNewCardAddForm(true)}
                    >
                      Add New Card <img src={Plusimg} alt="Plus icon" />
                    </Button>
                  )}
                </div>

                <div className="tsevo-container custom-payment-form-wrap">
                  <h4 className="text-start">{cardDisplayFormTitle}</h4>
                  {paymentError && (
                    <span style={{ color: 'red' }}>{paymentError}</span>
                  )}
                  <div id="gidx-form-container" ref={containerRef}></div>
                </div>

                <div className="transaction-summary">
                  <h4 className="text-start">Transaction Summary</h4>
                  <div className="summary-info">
                    <h5>
                      Amount: <span>${userData.user.usergame_amount}</span>
                    </h5>
                    {selectedCardNumber ? (
                      <h5 className="m-0">
                        Card: **** **** **** {selectedCardNumber}
                      </h5>
                    ) : (
                      ''
                    )}
                  </div>
                  <Button
                    variant="success"
                    className="btn-main"
                    onClick={() => completeCreditCardPayment()}
                    disabled={!sessionData?.data ? true : false}
                  >
                    Pay
                  </Button>
                </div>
              </>
            ) : (
              ''
            )}

            {creditCardpaymentCompleted ? (
              <div class="form-action">
                <button
                  type="button"
                  class="btn btn-primary "
                  id="paymentSuccessProcessed"
                  onClick={showPaymentProcessModal}
                >
                  Invite friends
                </button>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>

      <Modal
        show={showLocationRequiredPopup}
        onHide={cancelLocationRequiredPopup}
        className="modal-predict tsevo-flow"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h4 className="modal-title">{tsevoReconfirmationMessage}</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={enableLocationPopup}>
            Allow
          </Button>
          <Button variant="primary" onClick={cancelLocationRequiredPopup}>
            Don't Allow
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateLeagueStepPayment;
